// extracted by mini-css-extract-plugin
module.exports = {"textareaWrapper":"FormTextarea_textareaWrapper__2j31d","textarea":"FormTextarea_textarea__2chcI","label":"FormTextarea_label__33lC_","autofill":"FormTextarea_autofill__3yKQl"};